import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { ButtonComponent } from '~/app/shared/components/elements/buttons/button/button.component';
import { ButtonWithIconAltComponent } from '~/app/shared/components/elements/buttons/button-with-icon-alt/button-with-icon-alt.component';
import { H2Component } from '~/app/shared/components/elements/h2/h2.component';
import { IconComponent } from '~/app/shared/components/elements/icon/icon.component';
import { LabelComponent } from '~/app/shared/components/elements/label/label.component';
import { ModalRef } from '~/app/shared/services/modal/modal-ref';
import { Operation } from '~/app/shared/types/operation.type';

export type ModalOnboardingCallbackAction = 'START_FREE_TRIAL' | 'START_FREEMIUM';

@Component({
    selector: 'eb-modal-onboarding-new-member',
    templateUrl: './modal-onboarding-new-member.component.html',
    styleUrls: ['./modal-onboarding-new-member.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        H2Component,
        LabelComponent,
        ButtonComponent,
        IconComponent,
        ButtonWithIconAltComponent,
        TranslocoPipe,
    ]
})
export class ModalOnboardingNewMemberComponent {
    ref = inject<ModalRef<ModalOnboardingCallbackAction | null, {
    resumeFeatureOperation: Operation<unknown>;
    userName: string;
}>>(ModalRef);

    public isResumeFeatureOperation = typeof this.ref?.data.resumeFeatureOperation !== 'undefined';

    startFreeTrial() {
        this.ref.close('START_FREE_TRIAL');
    }

    startFreemium() {
        this.ref.close('START_FREEMIUM');
    }
}
